import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, computed, model } from '@angular/core';
import { MatFabButton } from '@angular/material/button';
import { DsrIconsModule } from '@desyre/icons-angular';

/**
 * Animation for rotating the icon when toggling chatbot visibility
 */
const rotateAnimation = trigger('rotateAnimation', [
  transition('default => rotated', animate('500ms ease-out', style({ transform: 'rotate(0deg)' }))),
  transition('rotated => default', animate('500ms ease-out', style({ transform: 'rotate(-360deg)' }))),
]);

/**
 * Animation for fading elements in and out
 */
const fadeAnimation = trigger('fadeAnimation', [
  transition(':enter', animate('150ms ease-in-out', style({ opacity: 1 }))),
  transition(':leave', animate('150ms ease-in-out', style({ opacity: 0 }))),
]);

@Component({
    selector: 'app-chatbot-collapse-button',
    templateUrl: './chatbot-collapse-button.component.html',
    styleUrls: ['./chatbot-collapse-button.component.sass'],
    animations: [rotateAnimation, fadeAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class ChatbotCollapseButtonComponent {
  /**
   * Model and computed properties
   */
  isCollapsibleChatbotOpen = model<boolean>(true);
  protected readonly iconName = computed(() =>
    this.isCollapsibleChatbotOpen() ? '' : 'speech-feedback'
  );
  protected readonly iconState = computed(() => (this.isCollapsibleChatbotOpen() ? 'rotated' : 'default'));

  /**
   * Toggles the chatbot visibility state when the button is clicked
   */
  toggleChatDisplay(): void {
    
    this.isCollapsibleChatbotOpen.update(currentState => !currentState);
  }
}